angular.module('harriApp')
.directive('hInput', [function($filter) {
    return {
        restrict:"E",
        replace: 'true',
        templateUrl: "modules/forms/components/formElementWrapper/input.html",
        scope: {
            serverErrorMessage:'=',
            name:'@',
            label:'@',
            errorMessage:'@',
            ngRequired:'=',
            ngModel:'='
        },
        link: function(scope, element, attrs) {
        }
    }
}]);